
export function convertirAString(datos:any): string {
    let formBody:string[]= [];
    for (const property in datos) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(datos[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    return formBody.join("&");
}

export function RutaBase(Espruebas:Boolean):string {
    if(Espruebas)
        return "";
    else
        return "/Bccr.Sugef.CIC_Ciudadano.SPA";
}


